import React, { useState, useEffect } from "react";

import MasonryLayout from "./MasonryLayout";
import { client } from "../client";
import { feedQuery, searchQuery } from "../utils/data";
import Spinner from "./Spinner";
import NotFound from "../assets/notFound.png";

const Search = ({ searchTerm, setSearchTerm }) => {
  const [posts, setPosts] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (searchTerm) {
      setLoading(true);
      const query = searchQuery(searchTerm.toLowerCase());
      client.fetch(query).then((data) => {
        setPosts(data);
        setLoading(false);
      });
    } else {
      client.fetch(feedQuery).then((data) => {
        setPosts(data);
        setLoading(false);
      });
    }
  }, [searchTerm]);

  return (
    <div>
      {loading && <Spinner msg={"Searching for posts"} />}
      {posts?.length !== 0 && <MasonryLayout posts={posts} />}
      {posts?.length === 0 && searchTerm !== "" && !loading && (
        <div className="w-full h-screen flex flex-col justify-center items-center">
          <p>Sorry 🙇 No Posts found</p>
          <img src={NotFound} className="w-[30%] mt-5" alt="" />
        </div>
      )}
    </div>
  );
};

export default Search;